<div class="space-y-4">
  <!-- Région administrative principale (fond blanc card) -->
  @if (primaryRegion()) {
    <div
      class="flex items-center gap-3.5 p-4 rounded-2xl bg-white dark:bg-neutral-2 border border-neutral-3 dark:border-neutral-4 shadow-xs"
    >
      <div
        class="w-10 h-10 rounded-xl bg-primary-2 text-primary-11 flex items-center justify-center shrink-0"
      >
        <mat-icon class="!w-5 !h-5 !text-xl">explore</mat-icon>
      </div>
      <div class="flex flex-col min-w-0">
        <span class="text-[11px] font-bold text-neutral-10 uppercase tracking-wider">
          Région administrative principale
        </span>
        <span class="text-sm font-extrabold text-neutral-12 truncate">
          {{ getRegionName(primaryRegion()) }}
        </span>
      </div>
    </div>
  }

  <!-- Zones et départements d'intervention -->
  @if (interventionZones() && interventionZones()!.length > 0) {
    @for (zone of interventionZones()!; track zone.country) {
      @let regionGroups = getDepartmentsByRegion(zone.departments);
      <div class="flex flex-col gap-3">
        <!-- Territoire national : France (fond blanc card) -->
        <div
          class="flex items-center justify-between p-3.5 bg-white dark:bg-neutral-2 rounded-xl border border-neutral-3 dark:border-neutral-4 shadow-xs"
        >
          <span class="text-xs font-bold text-neutral-12 uppercase tracking-wider flex items-center gap-2">
            <span
              class="w-7 h-7 rounded-lg bg-neutral-2 dark:bg-neutral-3 text-neutral-11 flex items-center justify-center shrink-0"
            >
              <mat-icon class="!w-4 !h-4 !text-base">public</mat-icon>
            </span>
            <span>Territoire national : {{ zone.country === 'FR' ? 'France' : zone.country }}</span>
          </span>
          <span
            class="text-xs font-semibold px-2.5 py-1 rounded-full bg-neutral-2 dark:bg-neutral-3 text-neutral-11 border border-neutral-3 dark:border-neutral-4"
          >
            {{ zone.departments?.length || 0 }} département(s) couvert(s)
          </span>
        </div>

        @if (regionGroups.length > 0) {
          <div class="flex flex-col gap-3">
            @for (group of regionGroups; track group.regionName) {
              <div
                class="flex flex-col gap-2.5 p-4 rounded-2xl border transition-all shadow-xs"
                [class.bg-white]="!group.isPrimary"
                [class.dark:bg-neutral-2]="!group.isPrimary"
                [class.border-neutral-3]="!group.isPrimary"
                [class.dark:border-neutral-4]="!group.isPrimary"
                [class.bg-primary-1/30]="group.isPrimary"
                [class.border-primary-4]="group.isPrimary"
              >
                <div class="flex items-center justify-between">
                  <div class="flex items-center gap-2">
                    <mat-icon
                      class="!w-4 !h-4 !text-base"
                      [class.text-primary-11]="group.isPrimary"
                      [class.text-neutral-9]="!group.isPrimary"
                    >
                      place
                    </mat-icon>
                    <span class="text-xs font-bold text-neutral-12">
                      {{ group.regionName }}
                    </span>
                    @if (group.isPrimary) {
                      <span
                        class="text-[10px] font-bold px-2 py-0.5 rounded-full bg-primary-3 text-primary-11"
                      >
                        Région principale
                      </span>
                    }
                  </div>
                  <span
                    class="text-[11px] font-mono font-medium text-neutral-10 bg-neutral-3 px-2 py-0.5 rounded-full"
                  >
                    {{ group.departments.length }} dép.
                  </span>
                </div>

                <div class="flex flex-wrap gap-2 pt-1">
                  @for (dept of group.departments; track dept.code) {
                    <span
                      class="inline-flex items-center gap-2 px-3 py-1.5 rounded-xl text-xs bg-white dark:bg-neutral-2 text-neutral-12 border border-neutral-3 dark:border-neutral-4 shadow-2xs hover:border-neutral-4 dark:hover:border-neutral-5 transition-colors"
                    >
                      <span
                        class="font-mono text-[11px] font-extrabold px-1.5 py-0.5 rounded-md"
                        [class.bg-primary-2]="group.isPrimary"
                        [class.text-primary-11]="group.isPrimary"
                        [class.bg-neutral-3]="!group.isPrimary"
                        [class.text-neutral-11]="!group.isPrimary"
                      >
                        {{ dept.code }}
                      </span>
                      <span class="font-medium">{{ dept.name }}</span>
                    </span>
                  }
                </div>
              </div>
            }
          </div>
        } @else {
          <div
            class="p-4 bg-white dark:bg-neutral-2 rounded-xl border border-primary-4 shadow-xs flex items-center gap-3"
          >
            <mat-icon class="text-primary-11">public</mat-icon>
            <div class="flex flex-col">
              <span class="text-xs font-bold text-primary-12">Couverture nationale intégrale</span>
              <span class="text-xs text-neutral-11">Actif sur l'ensemble des départements français.</span>
            </div>
          </div>
        }
      </div>
    }
  } @else {
    <div
      class="p-6 text-center border-2 border-dashed border-neutral-3 dark:border-neutral-4 rounded-2xl bg-white dark:bg-neutral-2 shadow-xs"
    >
      <mat-icon class="!w-8 !h-8 !text-2xl text-neutral-8 mb-2">map</mat-icon>
      <p class="text-sm font-semibold text-neutral-11">Aucun secteur d'intervention spécifié</p>
      <p class="text-xs text-neutral-9 mt-0.5">Configurez votre région et vos départements d'exercice.</p>
    </div>
  }
</div>
